<div class="d-flex align-items-center add-template-bottom p-2" [ngClass]="{'flex-wrap justify-content-end gap-1': templateType === 'Context'}" style="border-radius: 10px;">
  <div class="flex-grow-1">
    <div class="controls-section" [ngClass]="{ 'disabled': !isTemplateEditable }">

      <!-- Visibility -->
      <div class="control-item">
        <i class="fa fa-eye me-2"></i>
        <span class="control-label">Visibility</span>

        <div class="dropdown" dropdown>
          <button class="btn btn-visibility-outline-secondary btn-sm ms-2 border-0 rounded-pill dropdown-toggle"
                  dropdownToggle>
            {{ visibility }}
          </button>

          <ul class="dropdown-menu" *dropdownMenu>
            <li *ngFor="let v of ['Only Me', 'Everyone']">
              <a class="dropdown-item"
                 href="#"
                 (click)="isVisibilityEditable && onVisibilityChange(v); $event.preventDefault()">
                {{ v }}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <!-- Template Type & Sub Types -->
      <div class="control-item" 
           *ngIf="templateType !== 'Order' && templateType !== 'Clinical Order' && templateType !== 'Document' && !isCarePlanFamily()"
           [ngClass]="{ 'disabled': !isTemplateEditable }">

        <!-- Header icon + label -->
        <div class="d-flex align-items-center">
          <ng-container [ngSwitch]="templateType">

            <ng-container *ngSwitchCase="'Form'" >
              <!-- <i class="fa fa-list me-2"></i>
              <span class="control-label">Section:</span> -->
            </ng-container>

            <ng-container *ngSwitchCase="'Context'">
              <img src="assets/images/custom/templates/context_type.svg"
                   alt="context_type" class="me-2" width="13">
              <span class="control-label">Section:</span>
            </ng-container>

            <ng-container *ngSwitchDefault>
              <i class="fa fa-list me-2"></i>
              <span class="control-label">Section:</span>
            </ng-container>

          </ng-container>
        </div>

        <!-- Template Types Output -->
        <div class="template-types">

          <!-- SOAP: single fixed type -->
          <div *ngIf="templateType === 'SOAP'">
            <button class="btn btn-type-outline-secondary btn-sm border-0 rounded-pill" disabled>
              {{ templateType }}
            </button>
          </div>

          <!-- Order: only shows Plan subtype -->
          <div *ngIf="templateType === 'Order'">
            <button *ngFor="let type of filteredSelectedTypesForOrder"
                    class="btn btn-type-outline-secondary btn-sm border-0 rounded-pill"
                    disabled>
              {{ type }}
            </button>
          </div>

          <!-- Form & Context (shared rendering) -->
          <div *ngIf="templateType === 'Form' || templateType === 'Context'"
               class="d-flex align-items-center gap-1 flex-wrap position-relative">

            <!-- Selected Types -->
            <button *ngFor="let type of selectedTypes"
                    class="btn btn-type-outline-secondary btn-sm border-0 rounded-pill"
                    [class.d-none]="templateType === 'Form'"
                    (click)="isTemplateEditable && onRemoveType(type)"
                    [disabled]="!isTemplateEditable">
              {{ type }}
              <i class="fa fa-times ms-1 font-size-10" *ngIf="isTemplateEditable"></i>
            </button>

            <!-- Add button -->
            <button *ngIf="showPlusButton && templateType !== 'Form'"
                    class="btn btn-plus btn-sm rounded-pill"
                    (click)="onToggleDropdown()"
                    [disabled]="!isTemplateEditable">
              <i class="fa fa-plus font-size-15 align-middle"></i>
            </button>

            <!-- Dropdown (DRY version) -->
            <div *ngIf="showDropdown"
                 class="dropdown-menu show position-absolute additional-type-dropdown-menu">

              <a *ngFor="let opt of filteredTemplateSubtypeOptions"
                 class="dropdown-item"
                 href="#"
                 (click)="isTemplateEditable && onAddAdditionalType(opt); $event.preventDefault()"
                 [class.disabled]="
                     !isTemplateEditable || 
                     selectedTypes.includes(opt) ||
                     (templateType === 'Form' && selectedTypes.length >= 1) ||
                     (templateType === 'Context' && selectedTypes.length >= 3)
                 ">
                {{ opt }}
              </a>

            </div>

          </div>

        </div>
      </div>

      <!-- Context Sub Type -->
      <div class="control-item"
           *ngIf="shouldShowContextSubType && templateType !== 'Order' && templateType !== 'Clinical Order' && templateType !== 'Document' && !isCarePlanFamily()"

           [style.display]="(templateType === 'Order' || templateType === 'Clinical Order' || templateType === 'Document' || isCarePlanFamily()) ? 'none' : ''">

        <!-- <img src="assets/images/custom/templates/context_type.svg"
             class="me-2" width="13">
        <span class="control-label">Plan Sub Type:</span> -->

        <div class="dropdown" dropdown>
          <button class="btn btn-visibility-outline-secondary btn-sm ms-2 border-0 rounded-pill dropdown-toggle"
                  dropdownToggle
                  [disabled]="!isTemplateEditable">
            {{ contextSubType || 'Select Sub Type' }}
          </button>

          <ul class="dropdown-menu" *dropdownMenu>
            <li *ngFor="let option of contextSubTypeOptions">
              <a class="dropdown-item"
                 href="#"
                 (click)="isTemplateEditable && onContextSubTypeChange(option.value); $event.preventDefault()"
                 [class.disabled]="!isTemplateEditable">
                {{ option.label }}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <!-- Phrase / Prompt toggle -->
      <div class="control-item" *ngIf="shouldShowPhraseOrPrompt">
        <div class="d-flex gap-2 ms-2">
          <button type="button"
                  class="btn btn-sm border-0 rounded-pill"
                  [ngClass]="phraseOrPrompt === 'phrase' ? 'btn-phrase-active' : 'btn-phrase-inactive'"
                  (click)="onPhraseOrPromptChange('phrase')">
            Phrase
          </button>

          <button type="button"
                  class="btn btn-sm border-0 rounded-pill"
                  [ngClass]="phraseOrPrompt === 'prompt' ? 'btn-phrase-active' : 'btn-phrase-inactive'"
                  (click)="onPhraseOrPromptChange('prompt')">
            Prompt
          </button>
        </div>
      </div>

    </div>
  </div>

  <!-- Make Default -->
  <div class="d-flex flex-column align-items-end" *ngIf="showMakeDefault">
    <div class="d-flex align-items-center">
      <span class="mt-1 me-2">Make Default</span>

      <div class="form-check form-switch">
        <input type="checkbox"
               class="form-check-input"
               id="makeDefaultToggle"
               [checked]="isDefault"
               (change)="onIsDefaultChange($event)"
               [disabled]="!isTemplateEditable">
      </div>
    </div>
  </div>

  <!-- Author (for Order, Document, and Form templates) -->
  <div class="d-flex align-items-center version-control-item ms-2"
       *ngIf="(templateType === 'Order' || templateType === 'Clinical Order' || templateType === 'Document' || templateType === 'Form' || isCarePlanFamily() || templateType === 'Context') && createdBy">
    <i class="fa fa-user me-2"></i>
    <span class="control-label me-2">Author:</span>
    <span class="text-version">{{ createdBy | auditDisplayName }}</span>
  </div>

  <!-- Version -->
  <div class="d-flex align-items-center version-control-item ms-2"
       *ngIf="displayVersion !== ''">
    <i class="fa fa-list me-2"></i>
    <span class="control-label me-2">Version:</span>
    <span class="text-version">{{ displayVersion }}</span>
  </div>

</div>
